import React from "react";
import { motion } from "framer-motion";
import { manifesto } from "../lib/products";

export default function ManifestoChapters() {
  return (
    <section
      data-testid="manifesto"
      className="relative bg-[color:var(--sr-secondary)] grain py-24 md:py-40 overflow-hidden"
    >
      <div className="sr-container relative">
        <div className="grid grid-cols-12 gap-6 mb-16 md:mb-24">
          <motion.p
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{ duration: 0.6 }}
            className="col-span-12 md:col-span-3 label-eyebrow text-[color:var(--sr-primary)] flex items-center gap-3"
          >
            <span className="w-8 h-px bg-[color:var(--sr-accent)]" />
            Our philosophy
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.35 }}
            transition={{ duration: 0.9 }}
            className="col-span-12 md:col-span-9 font-serif text-5xl md:text-7xl lg:text-[6rem] leading-[0.92] tracking-tight text-[color:var(--sr-primary)]"
          >
            Our story begins
            <br />
            <em className="italic font-light">at the root.</em>
          </motion.h2>
        </div>

        <ol className="grid grid-cols-1 md:grid-cols-2 gap-x-12 lg:gap-x-24 gap-y-16 md:gap-y-24">
          {manifesto.map((c, idx) => (
            <motion.li
              key={c.number}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.9, delay: idx * 0.06 }}
              className={`grid grid-cols-12 gap-4 ${idx % 2 === 1 ? "md:mt-32" : ""}`}
              data-testid={`manifesto-chapter-${c.number}`}
            >
              <div className="col-span-3">
                <p className="font-serif text-6xl md:text-7xl text-[color:var(--sr-accent)] leading-none">
                  {c.number}
                </p>
                <p className="label-eyebrow text-[color:var(--sr-primary)] mt-3 opacity-70">
                  {c.label}
                </p>
              </div>
              <div className="col-span-9 pt-2">
                <h3 className="font-serif text-3xl md:text-4xl leading-tight text-[color:var(--sr-primary)] tracking-tight">
                  {c.title}
                </h3>
                <p className="text-[color:var(--sr-text)]/75 mt-4 leading-relaxed max-w-md">
                  {c.body}
                </p>
              </div>
            </motion.li>
          ))}
        </ol>
      </div>
    </section>
  );
}
